export enum CableGrouping {
    Enclosed = "enclosed",
    ClippedTouching = "clipped(touching)",
    ClippedSpaced = "clipped(spaced)",
}
